// Mirrors app/services/notifications/payload.rb: the first paint is rendered
// server side, everything after it here.

// Notifications are kept for a month, longer than it took to rename the scope.
const LEGACY_SCOPES = { 'comments.': 'messages.' }

export function translationKey(informations) {
  const key = informations['translation'] || ''
  const oldScope = Object.keys(LEGACY_SCOPES).find(scope => key.startsWith(scope))

  return oldScope ? key.replace(oldScope, LEGACY_SCOPES[oldScope]) : key
}

// The changed field is stored as its column name. Translating into a copy: a
// payload rendered twice would carry the label, which is no key of its own.
export function translationVariables(informations) {
  const variables = { ...informations['variables'] }
  const mainChange = variables['main_change']

  if (mainChange) {
    variables['main_change'] = I18n.t(`notifications.workorder.${mainChange}`, { defaultValue: mainChange })
  }
  return variables
}

export function notificationText(informations) {
  const key = translationKey(informations)
  if (!key) return ''

  return I18n.t(key, translationVariables(informations))
}
